export enum TagManagerEventType {
  click = 'click',
  pageview = 'pageview',
  signup = 'signup',
  tariffCalculationSubmitted = 'tariff_calculation_submitted',
  tariffEmailSubmitted = 'tariff_email_submitted',
  tariffMeetingBooked = 'tariff_meeting_booked',
  costModelLeadSubmitted = 'cost_model_lead_submitted',
}

export enum TagManagerPage {
  publicReportPage = '/public-report',
  registerPage = '/register',
}

export enum TagManagerAction {
  reportView = 'view',
  reportRequestReportAction = 'custom report request click',
  reportLearnMoreAction = 'learn more click',
  reportMuirLogoAction = 'Muir logo click',
  registerPageView = 'register page view',
  userSignup = 'user signup',
}
